import Utils from "../libs/Utils";
import PortUtils from "../portlibs/PortUtils";
import { Cols, TFrequency } from "../shared/Consts";
import GICHolding from "./GICHolding";

export default class SaveHolding extends GICHolding {
    get frequency() : TFrequency {return "m"}
    override computePayout() {
        this.resetPayout()
        this.excessDiv = 0;
        
        const hist = this.dividendHistory
        this.ytd_payout = hist.ytd
        
        const now = new Date()
        const current = now.getFullYear(), next = current+1, term = new Date(next+1, 1, 1, 0, 0, 0)
        let date = new Date(current, 0, 1, 0, 0, 0)
        while(date<term){
            const qty = hist.quantity(date)
            const div = hist.dividendOnMonth(date)
            const year = date.getFullYear()
            let payout = div || qty*this.yield/100/12;
            if (!PortUtils.isZero(payout)) {
                if (year==current) this.a_payout += payout
                else if (year==next) this.n_payout += payout
                this.distributions.push({
                    id:`${this.id} (${this.account})`,
                    date,amount:payout, holding:this, qty:qty, future:div==0
                })
            }
            date = Utils.dateAdd(date, {month:1})
        }
        return this;
    }
    value(col:string, toCad:boolean=false) : string{
        if (col==Cols.maturityMonth || col==Cols.maturity) return "N/A"
        else return super.value(col, toCad)
    }
    compValue(col:string) : number|string {
        if (col==Cols.maturityMonth || col==Cols.maturity) return -1
        else return super.compValue(col)
    }
}